var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVendasApp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 910"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 2",
    cx: 27,
    cy: 27,
    rx: 26.6766,
    ry: 27,
    fill: "#002868"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 894"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M32.8045 19.2857H31.0343C30.7621 19.2846 30.4981 19.3733 30.2879 19.5364C30.0777 19.6994 29.9344 19.9267 29.883 20.1788C29.8315 20.431 29.875 20.6922 30.0059 20.9172C30.1369 21.1423 30.3471 21.3172 30.6002 21.4116L32.3969 22.0895C32.6492 22.1842 32.8585 22.3589 32.989 22.5836C33.1194 22.8082 33.1628 23.0687 33.1117 23.3203C33.0605 23.5719 32.9181 23.7988 32.7088 23.9619C32.4995 24.1251 32.2365 24.2143 31.965 24.2143H30.1927",
    stroke: "#F8F7F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M31.4972 19.2857V18.4643",
    stroke: "#F8F7F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M31.4972 25.8571V24.2143",
    stroke: "#F8F7F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M31.0884 27.5C34.4753 27.5 37.2209 24.9256 37.2209 21.75C37.2209 18.5744 34.4753 16 31.0884 16C27.7015 16 24.9558 18.5744 24.9558 21.75C24.9558 24.9256 27.7015 27.5 31.0884 27.5Z",
    stroke: "#F8F7F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M30.3731 32.9722L36.925 30.8354L36.9703 30.8225C37.3389 30.74 37.7242 30.7973 38.0544 30.9836C38.3846 31.17 38.6371 31.4726 38.7647 31.8351C38.8924 32.1976 38.8864 32.5951 38.748 32.9534C38.6096 33.3117 38.3482 33.6064 38.0126 33.7823C25.2218 40.5433 28.4846 40.2378 15.1437 35.7007",
    stroke: "#F8F7F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M15.1437 27.5006H17.4424C20.1142 27.4705 22.7061 28.5089 24.7417 30.4251L24.7845 30.4667H29.0684C29.4957 30.4667 29.9055 30.6547 30.2077 30.9892C30.5098 31.3238 30.6796 31.7775 30.6796 32.2506C30.6798 32.7223 30.5114 33.1749 30.211 33.5094C29.9106 33.8439 29.5028 34.0331 29.0768 34.0356L22.5632 34.0714",
    stroke: "#F8F7F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendasApp);
export default __webpack_public_path__ + "static/media/vendas-app.ded576cb76d2ae480e6ff7dfc393b601.svg";
export { ForwardRef as ReactComponent };